
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { Dispatch, useEffect } from "react";
import { ConnectedProps, connect, useDispatch } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
import { AnyAction } from "redux";
import BaseLayout from "@components/BaseLayout";
import HtmlContent from "@components/common/HtmlContent";
import TranslatedHtml from "@components/common/TranslatedHtml";
import { setSettingsCustomerPreview } from "@redux/actions/application";
import { loadCurrentProcessAction } from "@redux/actions/processes";
import { AppState } from "@redux/reducer";
import { selectCurrentProcess } from "@redux/reducer/data";
import { getStringFromQuery } from "@services/routes";
const mapStateToProps = (state: AppState) => ({
    currentProcess: selectCurrentProcess(state),
});
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    loadCurrentProcess: () => dispatch(loadCurrentProcessAction())
});
const connector = connect(mapStateToProps, mapDispatchToProps);
type PageProps = ConnectedProps<typeof connector>;
/**
 * This page shows the imprint (Impressum) of the platform
 * using currentProcess.imprint, if given
 *
 */
const ImprintPage: React.FC<PageProps> = (props: PageProps) => {
    const { currentProcess, loadCurrentProcess } = props;
    const { t } = useTranslation("common");
    // #region hidden function to activate customerPreview
    // to activate call /about?customerPreview=ja
    // to access the value use
    // const customerPreview = useSelector((state: AppState) => state.applicationStates.settings.customerPreview)
    const dispatch = useDispatch();
    const router = useRouter();
    const customerPreview = getStringFromQuery(router, "customerPreview");
    useEffect(() => {
        if (customerPreview === "ja") {
            dispatch(setSettingsCustomerPreview(true));
        }
        else {
            // remove the setting on every other content
            if (customerPreview) {
                dispatch(setSettingsCustomerPreview(false));
            }
        }
    }, [customerPreview]);
    // #endregion
    useEffect(() => {
        if (!currentProcess) {
            loadCurrentProcess();
        }
    }, []);
    return <BaseLayout pageTitle={t("page.imprint.title")}>
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h1>{t("page.imprint.heading")}</h1>
            <TranslatedHtml content="page.imprint.title5TMG"/>
            {currentProcess?.imprint
            ? <HtmlContent content={currentProcess.imprint}/>
            : <TranslatedHtml content="page.imprint.responsableInstitution"/>}
            <TranslatedHtml content="page.imprint.mediaSupplier"/>
            <TranslatedHtml content="page.imprint.outtro"/>
          </Col>
        </Row>
      </CardBody>
    </Card>
  </BaseLayout>;
};
const __Next_Translate__Page__18c4f517164__ = connector(ImprintPage);

    export default __appWithI18n(__Next_Translate__Page__18c4f517164__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  